module.exports = __webpack_public_path__ + "img/cms.77f6760a.svg";